import log from 'salvo-lite/log'

import Vue from 'vue'
import AjaxAPI from '../helpers/AjaxAPI'
import Helpers from '../helpers/Helpers'
import Slick from 'vue-slick'

class RelatedProducts {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._section = elem.closest('section')
        this._data = {
            limit: 8,
            ...JSON.parse(elem.getAttribute('data-related-products') || '{}')
        }
        this._settings = JSON.parse(elem.parentNode.querySelector('[data-settings]').innerHTML)
        log.debug(this.constructor.name, 'Constructed', this)
    }

    async onInit () {
        const section = this._section
        const {productId, limit} = this._data
        const recommendationsResponse = await AjaxAPI.getProductRecommendations(productId, limit)
        const settings = this._settings
        const vue = new Vue({
            el: '[data-related-products]',
            data: {
                products: recommendationsResponse.data.products,
                settings: settings
            },
            computed: {

            },
            components: {
                'slick': Slick
            },
            mounted () {
                section.classList.remove('visually-hidden')
            },
            filters: {
                money (n) {
                    return Helpers.formatMoney(n)
                },
                img_url (imageSrc, dimensions) {
                    return Helpers.getSizedImageUrl(imageSrc, dimensions)
                }
            },
            methods: {

            }
        })

        window.vueJob = vue
    }
}

export default RelatedProducts



// WEBPACK FOOTER //
// ./src/resources/scripts/components/RelatedProducts.js